import { render } from "react-dom";
import OptInForm from "../components/OptInForm/OptInForm";
import OptInModal from "../components/OptInModal/OptInModal";

const bsdkOptInFormHandler = (prefix) => {
  const dom = document.getElementById(`${prefix}OptInForm`);

  if (dom) {
    const dataset = { ...dom.dataset } || {};
    Object.keys(dom.dataset).map((key) => delete dom.dataset[key]);
    render(<OptInForm prefix={prefix} {...dataset} />, dom);
  }

  const modalDom = document.getElementById(`${prefix}OptInModal`);
  if (modalDom) {
    const dataset = { ...modalDom.dataset } || {};
    Object.keys(modalDom.dataset).map((key) => delete modalDom.dataset[key]);
    render(<OptInModal prefix={prefix} {...dataset} />, modalDom);
  }
};

window.bsdkOptInFormHandler = bsdkOptInFormHandler;
